import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '../common/constants/language';

import enStation from '../common/locales/en/station.json';
import enFeature from '../common/locales/en/feature.json';
import enConfig from '../common/locales/en/config.json';
import enMiscellaneous from '../common/locales/en/miscellaneous.json';

import frStation from '../common/locales/fr/station.json';
import frFeature from '../common/locales/fr/feature.json';
import frConfig from '../common/locales/fr/config.json';
import frMiscellaneous from '../common/locales/fr/miscellaneous.json';

const resources = {
  en: {
    station: enStation,
    feature: enFeature,
    config: enConfig,
    miscellaneous: enMiscellaneous,
  },
  fr: {
    station: frStation,
    feature: frFeature,
    config: frConfig,
    miscellaneous: frMiscellaneous,
  },
};

const getStoredLanguagePreference = () => {
  try {
    // window.initialLanguage is set by the server inline script and reflects
    // the language the server rendered with — it must take priority over
    // localStorage to avoid a server/client hydration mismatch.
    if (typeof window !== 'undefined' && window.initialLanguage) {
      return window.initialLanguage;
    }

    let storedLocale = localStorage.getItem('gb_preferred_locale');
    if (storedLocale && !Object.values(SUPPORTED_LANGUAGES).includes(storedLocale)) {
      localStorage.setItem('gb_preferred_locale', SUPPORTED_LANGUAGES.ENGLISH);
      storedLocale = SUPPORTED_LANGUAGES.ENGLISH;
    }

    return storedLocale || SUPPORTED_LANGUAGES.ENGLISH;
  } catch {
    return SUPPORTED_LANGUAGES.ENGLISH;
  }
};

// Create a new i18next instance for our app
const appI18n = i18next.createInstance();

appI18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getStoredLanguagePreference(),
    fallbackLng: SUPPORTED_LANGUAGES.ENGLISH,
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
    },
  });

// Update localStorage when language changes
appI18n.on('languageChanged', (lng) => {
  try {
    if (Object.values(SUPPORTED_LANGUAGES).includes(lng)) {
      localStorage.setItem('gb_preferred_locale', lng);
    }
  } catch {
    // Ignore localStorage errors
  }
});

// Listen for storage events (changes from other tabs or RCC components)
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (event) => {
    if (event.key === 'gb_preferred_locale' && event.newValue && event.newValue !== appI18n.language) {
      appI18n.changeLanguage(event.newValue);
    }
  });
}

export default appI18n;
